import * as React from 'react';
const SvgMerchandise = (props) => (
  <svg viewBox="0 0 124 114" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m62.7 20.787-.054.11c-5.279 10.388-17.237 30.79-17.237 30.79l8.51 13.835M62.701 20.787l.055.11c5.278 10.388 17.236 30.79 17.236 30.79l-8.508 13.835M62.701 44.642v-9.67M67.471 51.35a4.984 4.984 0 0 0-3.347-6.195 4.968 4.968 0 0 0-6.181 3.355 4.984 4.984 0 0 0 3.347 6.196 4.968 4.968 0 0 0 6.181-3.356Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.232 65.487H51.175a3.3 3.3 0 0 0-3.295 3.303v4.066a3.3 3.3 0 0 0 3.295 3.303h23.057a3.3 3.3 0 0 0 3.295-3.303V68.79a3.3 3.3 0 0 0-3.295-3.303ZM95.986 8.228H68.858M56.553 8.228H27.318M66.821 2.06h-8.235a2.04 2.04 0 0 0-2.038 2.043v8.255a2.04 2.04 0 0 0 2.038 2.043h8.235a2.04 2.04 0 0 0 2.038-2.043V4.103a2.04 2.04 0 0 0-2.038-2.043ZM20.832 14.455c3.431 0 6.213-2.788 6.213-6.227 0-3.44-2.782-6.228-6.213-6.228s-6.213 2.788-6.213 6.228 2.782 6.227 6.213 6.227ZM102.661 14.455c3.431 0 6.213-2.788 6.213-6.227 0-3.44-2.782-6.228-6.213-6.228s-6.213 2.788-6.213 6.228 2.782 6.227 6.213 6.227Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M68.858 8.835C80.091 11.047 89.201 19.233 92.75 29.95M32.661 29.95c3.549-10.717 12.66-18.902 23.892-21.115M26.837 34.971h8.429c.417 0 .755.34.755.758v8.45a.756.756 0 0 1-.755.757h-8.43a.756.756 0 0 1-.755-.758v-8.45c0-.418.338-.757.756-.757ZM90.136 34.971h8.43c.417 0 .755.34.755.758v8.45a.756.756 0 0 1-.755.757h-8.43a.756.756 0 0 1-.755-.758v-8.45c0-.418.338-.757.755-.757ZM9.54 89.556V28.042a3.552 3.552 0 0 1 3.549-3.558h13.936M98.258 24.484h12.644a3.552 3.552 0 0 1 3.549 3.558v61.514M2 102.429v-7.328h44.707l5.278 5.171h20.03l5.273-5.171H122v7.328c0 5.286-4.274 9.571-9.548 9.571H11.548C6.274 112 2 107.715 2 102.429Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgMerchandise;
